import React, { useState } from "react";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from ".././Helmet";
import RelatedLinks from "../RelatedLinks";
const TITLE = "Calculatrice Triangle Hypoténuse";
const DESCRIPTION =
  "Calculatrice Triangle Hypoténuse pour faire vos calculs mathematiques rapidement et sans erreur. Saisissez vos valeurs et obtenez un resultat immediat avec une methode simple a verifier.";
const KEYWORDS =
  "triangle hypoténuse, calculatrice triangle hypoténuse, calcul en ligne, mathematiques, pourcentage, formule, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/triangle-hypotenuse";
function TriangleHypotenuseCalculator() {
  const [sideA, setSideA] = useState("");
  const [sideB, setSideB] = useState("");
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const handleCalculate = () => {
    try {
      const a = parseFloat(sideA);
      const b = parseFloat(sideB);
      if (isNaN(a) || isNaN(b)) {
        setError("Veuillez entrer des valeurs valides");
        setResult("");
        return;
      }
      const hyp = Math.sqrt(a * a + b * b).toFixed(2);
      setResult(hyp);
      setError("");
    } catch (err) {
      setError("Erreur de calcul");
    }
  };

  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: "50px" }}>
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <p>
                  Le <strong>théorème de Pythagore</strong> est l'un des résultats les plus célèbres
                  de la géométrie. Dans un triangle rectangle, le carré de l'hypoténuse est égal
                  à la somme des carrés des deux autres côtés : <strong>c = √(a² + b²)</strong>.
                  Entrez les longueurs des deux côtés pour calculer instantanément l'hypoténuse.
                </p>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div>
                  <div className="form-group">
                    <label>Côté A:</label>
                    <input
                      type="number"
                      value={sideA}
                      onChange={(e) => setSideA(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <div className="form-group">
                    <label>Côté B:</label>
                    <input
                      type="number"
                      value={sideB}
                      onChange={(e) => setSideB(e.target.value)}
                      className="form-control"
                    />
                  </div>
                  <button className="btn btn-success" onClick={handleCalculate}>
                    Calculer Hypoténuse
                  </button>
                </div>
                <br />
                {error && (
                  <p className="p-3 mb-2 bg-warning text-dark">
                    Erreur: {error}
                  </p>
                )}
                {result && (
                  <p className="p-3 mb-2 bg-success text-white">
                    Hypoténuse: {result}
                  </p>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
            <div className="row">
              <div className="col-sm-12 col-md-10">
                <div className="info-sections-container">
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Qu'est-ce que l'hypoténuse ?</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        L'hypoténuse est le côté le plus long d'un triangle rectangle,
                        situé en face de l'angle droit (90°).
                        Le théorème de Pythagore énonce que c² = a² + b², donc c = √(a² + b²).
                        Exemple classique : si a = 3 cm et b = 4 cm, alors c = √25 = <strong>5 cm</strong>.
                      </p>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Triplets pythagoriciens notables</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Certaines combinaisons d'entiers vérifient parfaitement c² = a² + b².
                        On les appelle triplets pythagoriciens :
                      </p>
                      <ul>
                        <li>(3, 4, 5) : 9 + 16 = 25 ✓</li>
                        <li>(5, 12, 13) : 25 + 144 = 169 ✓</li>
                        <li>(8, 15, 17) : 64 + 225 = 289 ✓</li>
                        <li>(7, 24, 25) : 49 + 576 = 625 ✓</li>
                      </ul>
                    </div>
                  </div>
                  <div className="info-section">
                    <div className="info-section-header">
                      <h3 style={{ fontSize: "16px" }}>Applications du théorème de Pythagore</h3>
                    </div>
                    <div className="info-section-body">
                      <p>
                        Ce théorème s'applique dans de nombreux domaines :
                      </p>
                      <ul>
                        <li><strong>Architecture :</strong> vérifier l'équerrage d'un mur ou d'une fondation</li>
                        <li><strong>Navigation :</strong> calculer la distance directe entre deux points GPS</li>
                        <li><strong>Informatique :</strong> distance euclidienne entre deux coordonnées</li>
                        <li><strong>Physique :</strong> résultante de deux forces perpendiculaires</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>

    </div>
  );
}
export default TriangleHypotenuseCalculator;
